var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('button',{staticClass:"top-of-view-button",on:{"click":_vm.handleClick}},[_c('TriangleIcon',{staticClass:"triangle-icon",attrs:{"direction":_vm.isRTL? 'right' : 'left'}}),_vm._v("\n    "+_vm._s(_vm.roomData.display_name)+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }